

































































import Vue from 'vue'

import { Button } from '@raksul/raksul-common-ui'
import ModalOverlay from '@/common/components/ModalOverlay.vue'

import LocalStorageSerializer from '@/common/localStorageSerializer'
import { SVG_PLACEHOLDER_IMAGES } from '@/common/constants'
import { LOCAL_STORAGE_TUTORIAL_DISABLED } from '@/stockLibrary/config/consts'

export default Vue.extend({
  components: { ModalOverlay, Button },
  props: {
    steps: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      currentIdx: 0,
      hideModal: true
    }
  },
  computed: {
    isFirstStep(): boolean {
      return this.currentIdx === 0
    },
    isFinalStep(): boolean{
      return this.currentIdx === this.steps.length - 1
    },
    placeholder(): string {
      return SVG_PLACEHOLDER_IMAGES.CATEGORY_BANNER
    }
  },
  methods: {
    nextStep(): void {
      this.currentIdx++
    },
    prevStep(): void {
      this.currentIdx--
    },
    closeModal(): void {
      if (this.hideModal) {
        LocalStorageSerializer.set(LOCAL_STORAGE_TUTORIAL_DISABLED, true)
      }
      this.$emit('close')
    }
  }
})
